import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto';
import { Resource } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';

export function setupTracer() {
  // Confgiuration for Signoz Collector
  const coralogixCollectorConfig = {
    url: 'https://otel-collector.conviva.com/v1/traces',
    headers: {
      'Content-Security-Policy': 'upgrade-insecure-requests',
    },
  };

  const resource = Resource.default().merge(
    new Resource({
      [SemanticResourceAttributes.SERVICE_NAME]: 'instant-filter-client',
    }),
  );

  // To start a trace, you first need to initialize the Tracer provider.
  const provider = new WebTracerProvider({
    resource,
  });

  const collectorCoralogixTraceExporter = new OTLPTraceExporter(coralogixCollectorConfig);

  // Below configuration is based upon the BatchSpanProcessor documentation
  const collectorCoralogixProcessor = new BatchSpanProcessor(collectorCoralogixTraceExporter, {
    // The maximum queue size. After the size is reached spans are dropped.
    maxQueueSize: 100,
    // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
    maxExportBatchSize: 10,
    // The interval between two consecutive exports
    scheduledDelayMillis: 500,
    // How long the export can run before it is cancelled
    exportTimeoutMillis: 30000,
  });

  // Adding the processor the tracer provider
  provider.addSpanProcessor(collectorCoralogixProcessor);

  // NOTE: The default OpenTelemetry tracer provider does not record any tracing information.
  //       Registering a working tracer provider allows the API methods to record traces.
  provider.register();
}
